import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppStore } from '../../store/applicationState'
import { GetAcquisitionPerformance } from '../../store/dashboard/actions'
import { TenderTypes } from '../../types/actions'
import { getCategoryId } from '../../utils/dashboardUtils/CategoriesHelpers'
import { PerformanceChart } from './Canvas/PerformanceChart'

interface activeTendersProps {
  userCategories: string[];
  activeTenders: TenderTypes;
  setActiveTenders: (value: TenderTypes) => void;
  setActiveSearch: (value: boolean) => void;
}

export const AcquisitionPerformance: React.FC<activeTendersProps> = ({
  userCategories,
  setActiveTenders,
  activeTenders,
  setActiveSearch,
}) => {
  const [loading, setLoading] = useState(false)
  const { dashboard } = useSelector((store: AppStore) => store)
  const dispatch = useDispatch()

  useEffect(() => {
    setLoading(true)
    dispatch(GetAcquisitionPerformance.request({
      idCategory: getCategoryId(activeTenders),
      callBack: (success) => {
        if (success) {
          setLoading(false)
        }
      },
    }))
  }, [activeTenders])

  const tenders = dashboard.data.acquisitionPerformance

  return (
    <div className="my-acquisition-performance perf mb-12 hidden smallMobile:block">
      <div className='flex justify-between items-end mb-6'>
        <div className='font-circa text-black text-lg font-semibold'>
          My Acquisition Performance
        </div>

        {userCategories.length > 1
        ? (
          <div className='tabs font-light flex justify-start space-x-12 ml-2'>
            {userCategories.includes('diamond') ? (
              <button
                type='button'
                className={`diamond-tab ${activeTenders === 'diamond' ? 'tab active' : 'tab'}`}
                onClick={() => {
                  setActiveTenders('diamond')
                  setActiveSearch(false)
                }}
              >
                Diamond Tenders
              </button>
            ) : null}

            {userCategories.includes('watches') ? (
              <button
                type='button'
                className={`watch-tab ${activeTenders === 'watches' ? 'tab active' : 'tab'}`}
                onClick={() => {
                  setActiveTenders('watches')
                  setActiveSearch(false)
                }}
              >
                Watch Tenders
              </button>
            ) : null}

            {userCategories.includes('jewelry') ? (
              <button
                type='button'
                className={`jewelry-tab ${activeTenders === 'jewelry' ? 'tab active' : 'tab'}`}
                onClick={() => {
                  setActiveTenders('jewelry')
                  setActiveSearch(false)
                }}
              >
                Jewelry Tenders
              </button>
            ) : null}
          </div>
        ) : ''}
      </div>

      <div className='message overflow-y-hidden'>
        {loading ? (
          null
        ): (
          <span>
            {tenders?.length
            ? (
              <PerformanceChart tenders={tenders} />
            ) : (
              <div>No performance data yet.</div>
            )}
          </span>
        )}
      </div>
    </div>
  )
}
